import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, NavigateFunction } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { login } from '../sessionReducer';
import { RootState } from '../../../rootReducer';
import LoginLayout from '../components/LoginLayout';
import LoginForm, { LoginFormModel } from '../components/LoginForm';
import Auth from '../../../Auth';

export interface LoginPageProps {
  nextPath?: string;
}

const LoginPage: React.FC<LoginPageProps> = ({ nextPath }) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<RootState, void, AnyAction>>();

  const sessionState = useSelector((state: RootState) => state.sessionReducer);

  const isError = sessionState.error;
  const isFetching = sessionState.isFetching;
  const loggedOut = sessionState.loggedOut;
  const expired = sessionState.expired;

  useEffect(() => {
    if (expired) {
      Auth.deauthenticateUser();
      return;
    }

    if (Auth.isUserAuthenticated()) {
      navigate(nextPath || '/', { replace: true });
    }
  }, [expired, navigate, nextPath]);

  const onSubmit = (values: LoginFormModel) => {
    const { email, password } = values;

    Auth.saveUsername('');
    Auth.savePassword('');

    dispatch(login(email, password, navigate, nextPath || '/'));
  };

  const initialValues: LoginFormModel = {
    email: Auth.getUsername(),
    password: Auth.getPassword(),
  };

  return (
    <LoginLayout>
      <LoginForm
        isFetching={isFetching}
        isError={isError}
        loggedOut={loggedOut}
        expired={expired}
        initialValues={initialValues}
        {...{ onSubmit }}
      />
    </LoginLayout>
  );
};

export default LoginPage;